module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "color": _vm.color
    }
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400",
      "padding-right": "15px"
    }
  }, [_vm._v("Filter by")]), _vm._v(" "), _c('v-btn-toggle', {
    attrs: {
      "small": "",
      "dense": "",
      "color": "info"
    },
    model: {
      value: (_vm.toggle_filter),
      callback: function($$v) {
        _vm.toggle_filter = $$v
      },
      expression: "toggle_filter"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.monthlyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Monthly\n              ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.quartelyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Quartely\n              ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.yearlyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Yearly\n              ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "max-width": "330",
      "height": "180",
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('p', {
    staticClass: "text-h6 text--primary"
  }, [_vm._v("\n              " + _vm._s(_vm.summaryTitle) + "\n              ")]), _vm._v(" "), _vm._l((_vm.summary), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "text--primary",
      staticStyle: {
        "font-size": "14px",
        "margin": "5px"
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + ": "), _c('strong', [_vm._v(_vm._s(item.value) + " " + _vm._s((_vm.name === 'revenue' ? 'SGD' : (_vm.name === 'renewal') ? '' : 'Days')))]), _vm._v(" "), (_vm.name === 'revenue' && index + 1 === _vm.summary.length) ? _c('div', {
      staticStyle: {
        "font-size": "14px",
        "margin": "5px 0px"
      }
    }, [_vm._v("Shortfall: "), _c('strong', [_vm._v(_vm._s((_vm.target - item.value)) + " SGD")])]) : _vm._e()])
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('canvas', {
    attrs: {
      "id": _vm.name,
      "width": "500",
      "height": "200"
    }
  })])], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "align": "end"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.detailCLick(_vm.name)
      }
    }
  }, [_vm._v("Details")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46019788"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AMDashboard/Chart/Bar.vue
// module id = 2102
// module chunks = 0